<template>
  <div class="front">
    <div class="top">
      <div style="color: #999999; line-height:  42px; height: 42px; margin-left: 50px">
        欢迎登录海军军医大学
      </div>
      <div style=" margin-right: 30px;">

        <el-dropdown>
          <span class="el-dropdown-link">
            <div style="display: flex; align-items: center;">
              <img :src="avatar" width="20px" height="20px" style="margin-right: 10px">
             {{form.userName}}
            </div>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item icon="el-icon-user-solid" @click.native="handleEdit()">个人信息</el-dropdown-item>
            <el-dropdown-item icon="el-icon-s-tools" >账号设置</el-dropdown-item>
            <el-dropdown-item icon="el-icon-switch-button" style="font-weight: bolder" @click.native="logout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
<!--
        <i class="el-icon-switch-button" style="font-weight: bolder; color: red; font-size: 20px; margin-left: 20px" @click="logout"></i>
-->
      </div>
    </div>

    <div>
      <router-view></router-view>
    </div>

    <div class="footer">
      <div style="margin: 0 auto; width: 500px; height: 100%; display: flex; align-items: center">
        <img src="../../assets/images/img_logo.png@2x.png" width="81px" height="81px">
        <div style="display: flex; flex-direction: column; margin-left: 50px">
          <div style="display: flex; align-items: center">
            <img src="../../assets/images/down_telephone.png.png">
            <span style="margin-left: 5px">
                联系我们: {{telephone}}
              </span>
          </div>
          <div style="display: flex; align-items: center">
            <img src="../../assets/images/down_address.png.png">
            <span style="margin-left: 5px">
                位置地址: {{position}}
              </span>
          </div>
          <div style="display: flex; align-items: center">
            <img src="../../assets/images/down_opinion.png.png">
            <span style="margin-left: 5px">
                意见建议
              </span>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-dialog title="用户信息" :visible.sync="dialogFormVisible" customClass="dialogClass">
        <div style="padding: 50px; width: 600px; margin: 0 auto">
          <el-form :model="form">
            <el-form-item label="用户名" :label-width="formLabelWidth">
              <el-input v-model="form.userName" readonly="readonly" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="出生年月" :label-width="formLabelWidth">
              <el-input v-model="form.birth"   autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="性别" :label-width="formLabelWidth">
              <el-input v-model="form.sex"   autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="家庭住址" :label-width="formLabelWidth">
              <el-input v-model="form.home"   autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="自我介绍" :label-width="formLabelWidth">
              <el-input type="textarea"   :rows="5" v-model="form.aboutUs" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
        </div>

        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">关  闭</el-button>
          <el-button type="primary" @click="updateUserInfo">保  存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
  import { getUserInfo,updateUser } from '../../request/api';

  export default {
    name: 'front',
    data() {
      return {
        dialogFormVisible: false,
        formLabelWidth: '100px',
        avatar: require("../../assets/avatar.png"),
        msg: 'Welcome to Your Vue.js App',
        telephone: "0078125400",
        position: "上海市杨浦区翔殷路800号",
        form: {
          userName: this.$route.params.userName,
          birth: this.$route.params.birth,
          sex: this.$route.params.sex,
          home: this.$route.params.home,
          aboutUs: this.$route.params.aboutUs
        },
      }
    },
    methods: {
      logout() {
        localStorage.removeItem("token");
        // 管理员页面
        this.$router.push('/');
      },
      handleEdit() {
        this.dialogFormVisible = true;
        //this.form.userName = this.$route.params.userInfo.userName;

      },
      loadUserInfo() {
        let param = {};
        getUserInfo(param).then(
          resp => {
            if (resp.code === 1) {
              // 渲染数据
              this.form = resp.data
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      },
      updateUserInfo() {
        let param = this.form;
        updateUser(param).then(
          resp => {
            if (resp.code === 1) {
              this.$message.success(resp.msg);
              this.loadUserInfo();
            } else {
              this.$message.error(resp.msg);
            }
          }
        ).catch(err => {
          console.log(err)
        })
      }
    },
    mounted() {
      // 加载用户信息
      this.loadUserInfo();
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
  .front {
    width: 100%;
    min-width: 1500px;
    max-width: 1920px;
    height: auto;
    display: flex;
    flex-direction: column;
  }

  .top {
    width: 100%;
    height: 42px;
    background-image: url("../../assets/images/top_bg.png");
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .dialogClass{
    min-width: 720px;
  }

  .footer {
    width: 100%;
    height: 199px;
    background-image: url("../../assets/images/down_porfile_bg.png");
  }

  .tool-bar {
    height: 500px;
  }

  .el-carousel__container {
    height: 500px
  }

  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }

  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }

  .aimcontent {
    width: 100%;
    height: 1900px;
    background-image: url("../../assets/images/bg@2x.png");
  }

  .a {
    position: absolute;
  }

  .b {
    position: absolute;
  }

  .left-but:hover {
    .b {
      display: block
    }

    .a {
      display: none
    }
  }

  .c {
    position: absolute;
  }

  .d {
    position: absolute;
  }

  .right-but:hover {
    .d {
      display: block
    }

    .c {
      display: none
    }
  }

  .pageWord {
    margin: 0 auto;
    width: 1100px;
    margin-top: 20px;
    text-align: left;

  }

  .pageWord span {
    font-size: 18px;
    line-height: 25px;
    margin-left: 5px
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Front.vue